import 'babel-polyfill';
import createFocusTrap from 'focus-trap/index.js';
import { PinClickEvent, PinHoverEvent, CardHoverEvent, CardClickEvent } from './Events.js';
import { OptimizedResizeInstance } from 'js/components/Util/OptimizedResize.js';
import { Maps } from 'js/components/Maps/index.js';
import { SearchMap } from 'js/search/modules/MapboxGL.js';

export class LocationMap extends SearchMap {
  static initClass() {
    Maps.FactoryForProvider.MapboxGL = (data) => new this(data);
    this.instances = [];
    this.providerLoaded = false;
    this.className = "Yext.Maps.LocationMap";
    this.breakPoint = 992;
  }


  constructor(args) {
    super(args);
    this.pinHeight = 48;
    this.pinWidth = 28;
    this.options.interactive = false;
    this.boundsOptions = {
      linear: true,
      duration: 0,
      animate: false,
      padding: {
        top: this.BUFFER,
        bottom: this.BUFFER + 220/2,
        left: this.BUFFER,
        right: this.BUFFER
      },
      maxZoom: 14
    };
  }

  svgPin(label, backgroundColor, textColor) {
    return `
      <svg width="28px" height="48px" viewBox="0 0 28 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <!-- Generator: sketchtool 51.2 (57519) - http://www.bohemiancoding.com/sketch -->
      <title>E3BF61D8-20F1-40C4-84C4-1B50A9C6ACB3</title>
      <desc>Created with sketchtool.</desc>
      <defs></defs>
      <g id="Styles" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="StyleGuide" transform="translate(-440.000000, -4043.000000)">
              <g id="Elements/Buttons/Pins/Location" transform="translate(440.000000, 4043.000000)">
                  <path d="M14,48 C14.6704102,48 15.007487,47.6666667 15,47 C15.5,29 28,24 28,14 C28,6 22,0 14,0 C6,0 0,6 0,14 C0,24 12.5,29 13,47 C13,47.6607478 13.3295899,48 14,48 Z" id="Background" fill="#3949AB" fill-rule="nonzero"></path>
                  <path d="M14,48 C14.6704102,48 15.007487,47.6666667 15,47 C15.5,29 28,24 28,14 C28,6 22,0 14,0 C6,0 0,6 0,14 C0,24 12.5,29 13,47 C13,47.6607478 13.3295899,48 14,48 Z" id="Border" opacity="0.5" fill-rule="nonzero"></path>
                  <circle id="Dot" fill="#FFFFFF" fill-rule="evenodd" cx="14" cy="14" r="6"></circle>
              </g>
          </g>
      </g>
    </svg>
  `;
  }
  iconImage(location, i) {
    return `data:image/svg+xml;charset=utf8,${encodeURIComponent(this.svgPin())}`;
  }
}
LocationMap.initClass();
